  <div  class="top-bar">
    <div class="version">
      <label >Version:  <strong>{{AppVersion}}</strong></label>
  </div>
    <img alt="Toppan Merrill" class="logo" src="../assets/logo-nexus.png" />
  </div>
   